import { useUrlStateContext } from './url-state-provider'

export function useUrlState() {
  const ctx = useUrlStateContext()
  if (!ctx) throw new Error('useUrlState must be used within UrlStateProvider')

  return ctx
}
